import BaseClient from './BaseClient';

class GroupAutomationRulesClient extends BaseClient {
    automationRulesDetails(teamId, groupId, params, config = {}) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/automation-rules/resource-details`;

        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }
}

export default new GroupAutomationRulesClient();
